// extracted by mini-css-extract-plugin
export default {"container":"app_container__yhzPe","card":"app_card__I87Iz"};